import React from "react";
import { object } from "prop-types";
import useStorage from "../../../hook/useStorage";
import StoryCard from "../../story-templates/story-card";
import SocialShareBottom from "../../story-templates/social-share";
import "./story-component.m.css"

const StoryComponent = ({ story,showAds=false}) => {
  const allTagId = useStorage();
  const allTagIds = allTagId[3];
return (
  <div styleName="story-body" className="story-body">
    <div>
      <article>
        <div itemProp="articleBody">
          {story.cards.map((card, index) => (

            <React.Fragment key={index}>
              <StoryCard key={card.id} card={card} story={story} />
              {showAds&&(index === 0 && (

                <div styleName="ad-container-inside-article" className="voice-no-read">
                  <div styleName="dsktop-ad">
                    {allTagIds["tagId_105046"]=== "sas_105046"&&<h2><span>Mainos (sisältö jatkuu alla)</span></h2>}
                    <div data-lazy-ad-unit-id="sas_105046" data-placement-id="artikkelimainos-1-desktop"></div>
                    {allTagIds["tagId_105046"]=== "sas_105046"&&<h2><span>Mainos päättyy</span></h2>}
                  </div>
                  <div styleName="mob-ad">
                    {allTagIds["tagId_105047"]=== "sas_105047"&&<h2><span>Mainos (sisältö jatkuu alla)</span></h2>}
                    <div data-lazy-ad-unit-id="sas_105047" data-placement-id="artikkelimainos-1-mobile"></div>
                    {allTagIds["tagId_105047"]=== "sas_105047"&&<h2><span>Mainos päättyy</span></h2>}
                  </div>
                </div>
              ))}
              {showAds&&(index === 1 && (
                <div styleName="ad-container-inside-article" className="voice-no-read">
                  <div styleName="dsktop-ad">
                    {allTagIds["tagId_106320"]=== "sas_106320"&&<h2><span>Mainos (sisältö jatkuu alla)</span></h2>}
                    <div data-lazy-ad-unit-id="sas_106320" data-placement-id="artikkelimainos-2-desktop"></div>
                    {allTagIds["tagId_106320"]=== "sas_106320"&&<h2><span>Mainos päättyy</span></h2>}
                  </div>
                  <div styleName="mob-ad">
                    {allTagIds["tagId_106321"]=== "sas_106321"&&<h2><span>Mainos (sisältö jatkuu alla)</span></h2>}
                    <div data-lazy-ad-unit-id="sas_106321" data-placement-id="artikkelimainos-2-mobile"></div>
                    {allTagIds["tagId_106321"]=== "sas_106321"&&<h2><span>Mainos päättyy</span></h2>}
                  </div>
                </div>
              ))}
              {showAds&&(index === 2 && (
                <div styleName="ad-container-inside-article" className="voice-no-read">
                  <div styleName="dsktop-ad">
                    {allTagIds["tagId_106322"]=== "sas_106322"&&<h2><span>Mainos (sisältö jatkuu alla)</span></h2>}
                    <div data-lazy-ad-unit-id="sas_106322" data-placement-id="artikkelimainos-3-desktop"></div>
                    {allTagIds["tagId_106322"]=== "sas_106322"&&<h2><span>Mainos päättyy</span></h2>}
                  </div>
                  <div styleName="mob-ad">
                    {allTagIds["tagId_106323"]=== "sas_106323"&&<h2><span>Mainos (sisältö jatkuu alla)</span></h2>}
                    <div data-lazy-ad-unit-id="sas_106323" data-placement-id="artikkelimainos-3-mobile"></div>
                    {allTagIds["tagId_106323"]=== "sas_106323"&&<h2><span>Mainos päättyy</span></h2>}
                  </div>
                </div>
              ))}
              {showAds&&(index === 3 && (
                <div styleName="ad-container-inside-article" className="voice-no-read">
                  <div styleName="dsktop-ad">
                    {allTagIds["tagId_106324"]=== "sas_106324"&&<h2><span>Mainos (sisältö jatkuu alla)</span></h2>}
                    <div data-lazy-ad-unit-id="sas_106324" data-placement-id="artikkelimainos-4-desktop"></div>
                    {allTagIds["tagId_106324"]=== "sas_106324"&&<h2><span>Mainos päättyy</span></h2>}
                  </div>
                  <div styleName="mob-ad">
                    {allTagIds["tagId_106325"]=== "sas_106325"&&<h2><span>Mainos (sisältö jatkuu alla)</span></h2>}
                    <div data-lazy-ad-unit-id="sas_106325" data-placement-id="artikkelimainos-4-mobile"></div>
                    {allTagIds["tagId_106325"]=== "sas_106325"&&<h2><span>Mainos päättyy</span></h2>}
                  </div>
                </div>
              ))}
            </React.Fragment>
          ))}
        </div>
        {<span className="article_end" styleName="article_end_style"></span>}
        <SocialShareBottom story={story} />
      </article>
      <div className="voice-no-read asiavirhe-wrapper" styleName="asiavirhe-wrapper">
        <a styleName="asiavirhe-link" href={`mailto:verkko@ilkkapohjalainen.fi?subject=Asiavirheilmoitus artikkelista ${story.headline}`} >Ilmoita asiavirheestä</a>
      </div>
    </div>
  </div>
  )
              }
StoryComponent.propTypes = {
  story: object
};
export default StoryComponent;
